/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M12 8L12 22"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M17 14H20C20 18.4183 16.4183 22 12 22C7.58175 22 4.00003 18.4183 4.00003 14H7.00003M12 8C10.3432 8 9.00003 6.65685 9.00003 5C9.00003 3.34315 10.3432 2 12 2C13.6569 2 15 3.34315 15 5C15 6.65685 13.6569 8 12 8Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<g opacity="0.12">
				<path
					d="M12 22C16.4183 22 20 18.4183 20 14H4.00003C4.00003 18.4183 7.58175 22 12 22Z"
					fill="currentColor"
				/>
				<path
					d="M15 5C15 6.65685 13.6569 8 12 8C10.3432 8 9.00003 6.65685 9.00003 5C9.00003 3.34315 10.3432 2 12 2C13.6569 2 15 3.34315 15 5Z"
					fill="currentColor"
				/>
			</g>
			<path
				d="M12 8C10.3432 8 9.00003 6.65685 9.00003 5C9.00003 3.34315 10.3432 2 12 2C13.6569 2 15 3.34315 15 5C15 6.65685 13.6569 8 12 8ZM12 8L12 22M12 22C16.4183 22 20 18.4183 20 14H17M12 22C7.58175 22 4.00003 18.4183 4.00003 14H7.00003"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				d="M11.9999 1.25C9.92887 1.25 8.24994 2.92893 8.24994 5C8.24994 6.81422 9.53826 8.32753 11.2499 8.67499L11.2499 21.2117C7.84482 20.8617 5.13822 18.1551 4.78826 14.75H6.99994C7.41415 14.75 7.74994 14.4142 7.74994 14C7.74994 13.5858 7.41415 13.25 6.99994 13.25L3.99994 13.25C3.58573 13.25 3.24994 13.5858 3.24994 14C3.24994 18.8325 7.16745 22.75 11.9999 22.75C16.8324 22.75 20.7499 18.8325 20.7499 14C20.7499 13.5858 20.4142 13.25 19.9999 13.25H16.9999C16.5857 13.25 16.2499 13.5858 16.2499 14C16.2499 14.4142 16.5857 14.75 16.9999 14.75H19.2116C18.8617 18.1551 16.1551 20.8617 12.7499 21.2117L12.7499 8.67499C14.4616 8.32753 15.7499 6.81422 15.7499 5C15.7499 2.92893 14.071 1.25 11.9999 1.25Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M12 8C10.3432 8 9.00003 6.65685 9.00003 5C9.00003 3.34315 10.3432 2 12 2M12 8C13.6569 8 15 6.65685 15 5M12 8L12 22M12 22C16.4183 22 20 18.4183 20 14H17M12 22C7.58175 22 4.00003 18.4183 4.00003 14H7.00003"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M12 8C10.3432 8 9.00001 6.65685 9.00001 5C9.00001 3.34315 10.3432 2 12 2C13.6569 2 15 3.34315 15 5C15 6.65685 13.6569 8 12 8ZM12 8L12 22M12 22C16.4183 22 20 18.4183 20 14H17M12 22C7.58174 22 4.00002 18.4183 4.00002 14H7.00002"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11.9999 7.25C12.4141 7.25 12.7499 7.58579 12.7499 8L12.7499 21.2117C16.155 20.8617 18.8616 18.1551 19.2116 14.75L16.9999 14.75C16.5857 14.75 16.2499 14.4142 16.2499 14C16.2499 13.5858 16.5857 13.25 16.9999 13.25L19.9999 13.25C20.4141 13.25 20.7499 13.5858 20.7499 14C20.7499 18.8325 16.8324 22.75 11.9999 22.75C7.16739 22.75 3.24988 18.8325 3.24988 14C3.24988 13.5858 3.58566 13.25 3.99988 13.25L6.99988 13.25C7.41409 13.25 7.74988 13.5858 7.74988 14C7.74988 14.4142 7.41409 14.75 6.99988 14.75L4.7882 14.75C5.13816 18.1551 7.84476 20.8617 11.2499 21.2117L11.2499 8C11.2499 7.58579 11.5857 7.25 11.9999 7.25Z"
				fill="currentColor"
			/>
			<path
				d="M12.0001 1.25C9.92899 1.25 8.25006 2.92893 8.25006 5C8.25006 7.07107 9.92899 8.75 12.0001 8.75C14.0711 8.75 15.7501 7.07107 15.7501 5C15.7501 2.92893 14.0711 1.25 12.0001 1.25Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
